var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMagnifyingGlass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8024 18.645L14.5481 13.3907C15.875 11.7595 16.5254 9.68142 16.3654 7.58466C16.2053 5.48804 15.2468 3.53287 13.6875 2.12204C12.1284 0.711343 10.0873 -0.0473442 7.9852 0.00229039C5.88306 0.0521361 3.8801 0.906457 2.38938 2.3894C0.9065 3.88017 0.0521618 5.8832 0.00229294 7.98525C-0.0473695 10.0874 0.711293 12.1285 2.12202 13.6876C3.53289 15.2469 5.48805 16.2054 7.58461 16.3655C9.68121 16.5255 11.7593 15.8751 13.3906 14.5482L18.6449 19.8025C18.8564 19.9836 19.145 20.0451 19.4118 19.9663C19.6787 19.8874 19.8874 19.6786 19.9663 19.4118C20.0451 19.145 19.9834 18.8565 19.8024 18.645ZM3.54692 12.8409C2.3147 11.6094 1.62221 9.93864 1.62183 8.1966C1.62147 6.45437 2.31324 4.78345 3.5449 3.5514C4.77675 2.31935 6.44748 1.62719 8.1897 1.62719C9.93173 1.62719 11.6026 2.31935 12.8343 3.5514C14.0662 4.78345 14.7579 6.45437 14.7576 8.1966C14.7572 9.93864 14.0645 11.6094 12.8323 12.8409C11.6061 14.0817 9.93412 14.7801 8.1897 14.7801C6.44509 14.7801 4.77309 14.0817 3.54692 12.8409Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifyingGlass);
export default __webpack_public_path__ + "static/media/magnifyingGlass.55b1f6cfb8460f16e7c5f1b36fbee1a5.svg";
export { ForwardRef as ReactComponent };